export default {"src":"/_next/static/media/0xcafcd85d8ca7ad1e1c6f82f651fa15e33aefd07b.cac1eece.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};